import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, isRef as _isRef, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Назад к пациентам ")


import { storeToRefs } from 'pinia';
import {
  defineComponent, onBeforeMount, ref, defineAsyncComponent, shallowRef, watch,
} from 'vue';
import { useMainStore } from '@/store';
import { useTreeStore } from '~store/tree/treeModule';
import TreeComponent from '@/components/tree/TreeComponent.vue';
import { IRouterTab } from '@/types';
import DatePickerAnchorButton from '@/components/DatePickerAnchorButton.vue';
import { presets } from '@/composables';
import { usePatientsStore } from '@/store/patients/patientsModule';
import AppLoader from '@/components/AppLoader.vue';

const __default__ = defineComponent({
  name: 'StructureView',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  query: {
    type: Object as () => { [key: string]: string },
    default: () => ({ param: '1' }),
    required: true,
  },
},
  setup(__props) {

const splitterModel = ref(30);
const treeStore = useTreeStore();
const mainStore = useMainStore();
const patientsStore = usePatientsStore();

const tabs: IRouterTab[] = [
  {
    id: 1,
    component: 'Patients',
    label: 'Пациенты',
    icon: 'people',
  },
  {
    id: 2,
    component: 'EmployeesLists',
    label: 'Списки',
    icon: 'lists',
  },
  {
    id: 3,
    component: 'Questions',
    label: 'Анкеты',
    icon: 'dynamic_form',
    disable: true,
  },
];



const { treeData } = storeToRefs(treeStore);
const { activeTabId } = storeToRefs(mainStore);
const { tableMode, dates, tableLoading } = storeToRefs(patientsStore);

const isTreeLoading = ref(false);

const loadTreeData = async () => {
  isTreeLoading.value = true;
  await treeStore.loadTree();
  isTreeLoading.value = false;
};

if (!treeData.value.data || !treeData.value.data.length) {
  loadTreeData();
}
onBeforeMount(() => {
  component.value = defineAsyncComponent(
    () => import(`~components/tables/${activeTab.value.component}.vue`),
  );
  if (!dates.value.date_from || !dates.value.date_till) {
    const defaultPreset = presets[0];
    const payload = {
      date_from: defaultPreset.startDate.toLocaleDateString('ru-RU'),
      date_till: defaultPreset.endDate.toLocaleDateString('ru-RU'),
    };
    usePatientsStore().setDates(payload);
  }
});

const component = shallowRef(
  defineAsyncComponent(() => import(`~components/tables/${activeTab.value.component}.vue`)),
);

const activeTab = ref(tabs.find((item) => item.id === activeTabId.value) as IRouterTab);

const onTabSelect = async (val: number) => {
  activeTab.value = tabs.find((item) => item.id === val) as IRouterTab;
  mainStore.setCurrentStructureTab(val);
  component.value = defineAsyncComponent(
    () => import(`~components/tables/${activeTab.value.component}.vue`),
  );
};

const backToPatients = () => {
  patientsStore.setTableMode(0);
  patientsStore.getTableData();
};

watch(tableMode, () => onTabSelect(tableMode.value));

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_splitter, {
      modelValue: splitterModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((splitterModel).value = $event)),
      limits: [10, 70],
      style: {"height":"100%","width":"100%"}
    }, {
      before: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(treeData).data)
            ? (_openBlock(), _createBlock(TreeComponent, { key: 0 }))
            : _createCommentVNode("", true),
          (isTreeLoading.value)
            ? (_openBlock(), _createBlock(AppLoader, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ]),
      after: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_unref(tableMode) !== 0)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                class: "back-button",
                flat: "",
                round: "",
                color: "accent",
                icon: "arrow_back_ios",
                onClick: backToPatients
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(DatePickerAnchorButton),
          _createVNode(_component_q_tabs, {
            class: "text-accent shifted-tabs",
            "inline-label": "",
            align: "left",
            "onUpdate:modelValue": [
              onTabSelect,
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeTabId) ? (activeTabId).value = $event : null))
            ],
            modelValue: _unref(activeTabId)
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                return _createVNode(_component_q_tab, _mergeProps({
                  key: tab.id,
                  name: tab.id
                }, tab), null, 16, ["name"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_tab_panels, { "model-value": _unref(activeTabId) }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                return _createVNode(_component_q_tab_panel, {
                  key: tab.id,
                  name: tab.id
                }, {
                  default: _withCtx(() => [
                    (_unref(tableLoading))
                      ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
                      : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), { key: 1 }))
                  ]),
                  _: 2
                }, 1032, ["name"])
              }), 64))
            ]),
            _: 1
          }, 8, ["model-value"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})